'use client';
import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { RoundButton } from '@osmosis/react-ui/components/RoundButton';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { A } from '@osmosis/react-ui/components/Text';
import { H1 } from '@osmosis/react-ui/components/Text';
import { P } from '@osmosis/react-ui/components/Text';
import { FormattedMessage } from 'react-intl';
import AnimatedMagnifyingGlassIcon from './icons/AnimatedMagnifyingGlassIcon';
import { darken } from '@osmosis/shared/styles/colorModifiers';
import HeaderTitle from './HeaderTitle';

/**
 * Not Found UI.
 * @param param0
 * @returns
 */
export default function NotFound404() {
  const colors = useColors();
  const textColor = darken(0.6, colors.text);
  return (
    <>
      <HeaderTitle title="Osmosis - 404 Page not Found" />
      <Flex
        bg="primary"
        height="100vh"
        alignItems={['normal', 'start']}
        justifyContent="center"
        data-testid="container"
        p={3}
      >
        <Flex
          flexDirection="column"
          justifyContent="space-between"
          mt={[0, 4]}
          flex={1}
          maxWidth="940px"
          bg="bg-0"
          textAlign="center"
          p={4}
          sx={{ borderRadius: '5px' }}
        >
          <H1 mt={[0, 4]} fontSize={[5, 6, 7]} color="text" fontWeight="600">
            <FormattedMessage
              defaultMessage="<span>404</span> Page Not Found"
              id="not_found_page.page_not_found"
              values={{
                span: (chunk) => (
                  <P
                    key="span"
                    color={darken(0.3, colors.text)}
                    fontSize="inherit"
                    as="span"
                  >
                    {chunk}
                  </P>
                ),
              }}
            />
          </H1>
          <Box height={['unset', 'unset', '50vh']}>
            <AnimatedMagnifyingGlassIcon />
          </Box>
          <Box>
            <P color={textColor} fontSize={[3, 4, 4]}>
              <FormattedMessage
                defaultMessage="Sorry, I've looked everywhere but I can't find this page!"
                id="not_found_page.cant_find_page"
              />
            </P>
            <P color={textColor} my={4} fontSize={[2, 3, 3]}>
              <FormattedMessage
                defaultMessage="Maybe head back to the <a>homepage</a> and try again?"
                id="not_found_page.homepage_link"
                values={{
                  a: (chunk) => (
                    <A key="a" fontSize="inherit" href="/" color="primaryText">
                      {chunk}
                    </A>
                  ),
                }}
              />
            </P>
            <RoundButton mx="auto" as="a" href="/" maxWidth="150px">
              <FormattedMessage
                defaultMessage="Return Home"
                id="not_found_page.return_home"
              />
            </RoundButton>
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
